export default {
  state:{
    desc: '',
  },
  mutations:{
    setdesc: (store, data) => {
      store.desc = data;
    },
  },
  actions:{
    changedesc({commit}, {data}){
      commit('setdesc', data);
    },

  }
};
